import { render, staticRenderFns } from "./Candidate.vue?vue&type=template&id=7ffe03fb&scoped=true&"
import script from "./Candidate.vue?vue&type=script&lang=js&"
export * from "./Candidate.vue?vue&type=script&lang=js&"
import style0 from "./Candidate.vue?vue&type=style&index=0&id=7ffe03fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe03fb",
  null
  
)

export default component.exports